import axios from "axios";
import { API } from "./uploads";
import { getSessionId } from "./session";

export async function submitFeedback(body) {
  const res = await axios.post(`${API}/feedback`, body, {
    headers: { "X-Session-Id": getSessionId() },
  });
  return res.data;
}

const DISMISS_PREFIX = "kyp_feedback_dismissed_";
const SUBMITTED_PREFIX = "kyp_feedback_submitted_";

export function markPromptDismissed(uploadId) {
  try {
    localStorage.setItem(DISMISS_PREFIX + uploadId, "1");
  } catch (e) {}
}

export function wasPromptDismissed(uploadId) {
  try {
    return localStorage.getItem(DISMISS_PREFIX + uploadId) === "1";
  } catch (e) {
    return false;
  }
}

export function markFeedbackSubmitted(uploadId) {
  try {
    localStorage.setItem(SUBMITTED_PREFIX + uploadId, "1");
  } catch (e) {}
}

export function wasFeedbackSubmitted(uploadId) {
  try {
    return localStorage.getItem(SUBMITTED_PREFIX + uploadId) === "1";
  } catch (e) {
    return false;
  }
}
